import { Component, OnInit } from '@angular/core';
import { ReferencesService } from './references.service';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.scss']
})
export class ReferencesComponent implements OnInit {
  public references;
  hideme = {};
  selectedIndex = -1;
  expanded: Boolean = false;

  test(id:number, slug:string){
    this.router.navigate(['references', slug]);
    this.selectedIndex = id;
    console.log(this.expanded, this.selectedIndex)
  }

  constructor(
    private referencesService: ReferencesService,
    private http: HttpClient,
    private router: Router
  ) {
    this.hideme = {};
    router.events.forEach((event) => {
      if(event instanceof NavigationStart) {
        this.expanded = true;
        console.log('route changed')
      }
    });
  }

  ngOnInit() {
    this.getReferences();
  }

  getReferences() {
    this.referencesService.getReferences().subscribe(
      data => { this.references = data },
      err => console.error(err)
      // () => console.log(this.references)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/references/references.component.ts